import React from 'react';
import TextField from '@material-ui/core/TextField';
import { Icon } from 'veloe-ds';
import InputAdornment from '@material-ui/core/InputAdornment';

import InputMask from 'react-input-mask';

import './CepInput.scss';

import truck from '../../../assets/icons/truck.svg';
import alert from '../../../assets/icons/alert.svg';

const CepInput = ({
  onChange,
  errorMessage = '',
  isValid = false,
  tooltip,
  label,
  value,
}) => {
  const showIcon = isValid
    ? {
        endAdornment: (
          <InputAdornment position="end">
            <Icon src={alert} size="md" className="teste" />
          </InputAdornment>
        ),
      }
    : {};

  return (
    <>
      <InputMask
        mask="99999-999"
        maskChar={null}
        onChange={onChange}
        value={value}
      >
        {() => (
          <TextField
            className="veloe-input-text on-light-bg"
            label={label}
            helperText={isValid ? errorMessage : ''}
            variant="filled"
            error={isValid}
            onChange={onChange}
            InputProps={showIcon}
            value={value}
          />
        )}
      </InputMask>

      {tooltip && (
        <div className="containerFreteGratis">
          <Icon src={truck} size="md" />
          <label className="lblFreteGratis">
            Para você, a entrega fica por nossa conta ;)
          </label>
        </div>
      )}
    </>
  );
};

export default CepInput;
